<div class="progress-tab-line">
  <div *ngFor="let step of steps"
       class="tab"
       [class.tab-active]="isActive(step)">
    <span class="tab-badge">{{ step.stepNo }}</span>
    <span class="tab-label">{{ step.stepName }}</span>
  </div>
</div>
